import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/legal-page";

export const Route = createFileRoute("/terms-and-conditions")({
  head: () => ({
    meta: [
      { title: "Terms and Conditions - DeckScore" },
      { name: "description", content: "The terms that govern your use of DeckScore." },
      { name: "robots", content: "noindex" },
      { property: "og:title", content: "Terms and Conditions - DeckScore" },
      { property: "og:description", content: "The terms that govern your use of DeckScore." },
    ],
  }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <LegalPage title="Terms and Conditions">
      <p><strong>Terms and Conditions</strong></p>
      <p><strong>Effective Date: 11 July 2026</strong></p>
      <p>
        Welcome to DeckScore, a platform provided by Adviselo Collab Studios Private Limited. These Terms and Conditions ("Terms") govern your access to and use of the DeckScore website, services, and tools (collectively, the "Platform"). By using DeckScore, you agree to these Terms. If you do not agree, you must not use the Platform.
      </p>

      <h2>1. Eligibility</h2>
      <p>To use DeckScore, you must be at least 18 years old and have the legal authority to enter into these Terms. By using the Platform, you confirm that you meet these requirements.</p>

      <h2>2. Our Services</h2>
      <p>
        DeckScore provides: (a) a free AI-powered pitch-deck analysis that gives slide-by-slide scores, content and design suggestions, and an overall investor-readiness score; and (b) a paid investor-introduction service in which we prepare and email your one-pager to relevant investors as a warm introduction. Our analysis and scores are informational and do not guarantee any investment, meeting, or fundraising outcome.
      </p>

      <h2>3. Use of the Platform</h2>
      <p>You agree to:</p>
      <ul>
        <li>Provide accurate, current, and complete information</li>
        <li>Use the Platform only for lawful purposes</li>
        <li>Not attempt to reverse engineer, copy, or misuse any part of the service</li>
        <li>Not upload or distribute any malicious code or harmful content</li>
      </ul>
      <p>We reserve the right to suspend or terminate your account for violations of these Terms.</p>

      <h2>4. User Accounts</h2>
      <p>You are responsible for maintaining the confidentiality of your account credentials and must notify us immediately of any unauthorized access.</p>

      <h2>5. Payments and Paid Services</h2>
      <p>DeckScore offers free and paid services. By purchasing a paid service:</p>
      <ul>
        <li>You agree to be charged at the time of checkout unless otherwise stated.</li>
        <li>You authorize us to prepare and send your one-pager and pitch materials to investors on your behalf.</li>
        <li>Refunds are governed by our Cancellation &amp; Refund Policy.</li>
      </ul>

      <h2>6. Intellectual Property</h2>
      <p>
        All content and software on DeckScore (excluding user-submitted data) are the intellectual property of Adviselo Collab Studios Private Limited. You may not copy, reuse, or distribute this content without permission. You retain ownership of the pitch materials you upload and grant us a limited license to process and, for paid services, transmit them for the purpose of providing the service.
      </p>

      <h2>7. Data Protection and Privacy</h2>
      <p>We collect and process personal data in accordance with our Privacy Policy.</p>

      <h2>8. Third-Party Services</h2>
      <p>
        DeckScore may link to or integrate third-party websites and services (including payment processors and investors). We are not responsible for their content, privacy practices, or performance.
      </p>

      <h2>9. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, DeckScore and its affiliates are not liable for any indirect or consequential losses, loss of data, profits, or business opportunity, or any decision made based on information provided on the platform. Our total liability shall not exceed the amount you paid to us in the last 12 months.
      </p>

      <h2>10. Governing Law</h2>
      <p>These Terms are governed by the laws of India, and any disputes are subject to the exclusive jurisdiction of the courts of Surat, Gujarat.</p>

      <h2>11. Changes to These Terms</h2>
      <p>We may update these Terms from time to time. All changes will be reflected in the latest version available on the Platform. It is your responsibility to review the Terms periodically.</p>

      <h2>12. Termination</h2>
      <p>You may stop using DeckScore at any time. We may suspend or terminate your access if you violate these Terms. Termination does not affect rights and obligations already accrued.</p>

      <h2>13. Contact</h2>
      <p>Email: <a href="mailto:info@ikomatch.com">info@ikomatch.com</a> · Adviselo Collab Studios Private Limited, Surat, Gujarat, India.</p>
    </LegalPage>
  );
}
